window.VH = window.VH === undefined ? {} : window.VH;

VH.Order = {
    timeout : 180000,

    init : function init()
    {
        let _t = VH.Order;
        VH.PageUpdater.init(_t.timeout, $('#utxUpdateLink').attr('href'));
    }
};
